export const initFrontpageCard2IconGradients = () => {
  const svgNamespace = "http://www.w3.org/2000/svg";
  const cardIcons = document.querySelectorAll(
    ".himml-frontpage-cards-2 .wp-block-outermost-icon-block svg"
  );

  cardIcons.forEach((svg, index) => {
    if (!(svg instanceof SVGSVGElement)) return;

    const gradientId = `himml-frontpage-cards-2-gradient-${index}`;
    let defs = svg.querySelector("defs");

    if (!defs) {
      defs = document.createElementNS(svgNamespace, "defs");
      svg.prepend(defs);
    }

    let gradient = defs.querySelector(`#${gradientId}`);
    if (!gradient) {
      gradient = document.createElementNS(svgNamespace, "linearGradient");
      gradient.setAttribute("id", gradientId);
      gradient.setAttribute("x1", "0%");
      gradient.setAttribute("y1", "0%");
      gradient.setAttribute("x2", "100%");
      gradient.setAttribute("y2", "100%");

      const start = document.createElementNS(svgNamespace, "stop");
      start.setAttribute("offset", "0%");
      start.setAttribute("stop-color", "#0e4194");

      const end = document.createElementNS(svgNamespace, "stop");
      end.setAttribute("offset", "100%");
      end.setAttribute("stop-color", "#60a5fa");

      gradient.append(start, end);
      defs.appendChild(gradient);
    }

    svg.querySelectorAll("path").forEach((path) => {
      path.setAttribute("fill", `url(#${gradientId})`);
    });
  });
};
